import { create } from 'zustand';
const useTasksDrawerStore = create((set)=>({
        isDrawerOpen: false,
        openDrawer: ()=>set({
                isDrawerOpen: true
            }),
        closeDrawer: ()=>set({
                isDrawerOpen: false
            }),
        toggle: ()=>set((s)=>({
                    isDrawerOpen: !s.isDrawerOpen
                }))
    }));
export { useTasksDrawerStore };
export function useTasksDrawer() {
    const isDrawerOpen = useTasksDrawerStore((s)=>s.isDrawerOpen);
    const openDrawer = useTasksDrawerStore((s)=>s.openDrawer);
    const closeDrawer = useTasksDrawerStore((s)=>s.closeDrawer);
    const toggle = useTasksDrawerStore((s)=>s.toggle);
    return {
        isDrawerOpen,
        openDrawer,
        closeDrawer,
        toggle
    };
}
